import React, { useState, useEffect, useRef } from 'react';
import { useAuth } from '../../../utils/authService';
import { useNavigate } from "react-router-dom";
import { db } from '../../../utils/firebase-config';
import { doc, getDoc, updateDoc } from "firebase/firestore";
import VideoComponent from '../VideoComponent';
import QuizComponent from '../QuizComponent';
import StepHeader from '../StepHeader';
import updateUserProgress from '../userProgressTrack/updateUserProgress'; 
import masterclassSteps from '../Questions/Masterclass';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft, faChevronRight, faPlay } from '@fortawesome/free-solid-svg-icons';


const MasterClass = () => {
  const { user } = useAuth();
  const [userId, setUserId] = useState(user ? user.uid : null);
  const [currentStep, setCurrentStep] = useState(0);
  const [currentSubStep, setCurrentSubStep] = useState(1);
  const [shuffledQuestions, setShuffledQuestions] = useState([]);
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [selectedOptions, setSelectedOptions] = useState({});
  const [showReviewPopup, setShowReviewPopup] = useState(false);
  const [canSlide, setCanSlide] = useState(false);
  const sliderRef = useRef(null);
  const [activeSlide, setActiveSlide] = useState(0);
  const navigate = useNavigate();
  const [correctAnswersCount, setCorrectAnswersCount] = useState(0);
  const [incorrectAnswersCount, setIncorrectAnswersCount] = useState(0);
  const [isRetrying, setIsRetrying] = useState(false);


  const currentStepData = masterclassSteps.find(step => step.id === currentStep);
  const currentSubStepData = currentStepData?.subSteps?.[currentSubStep];
  const isLastSubStep = currentSubStep === Object.keys(currentStepData?.subSteps || {}).length;
  const [completedSubsteps, setCompletedSubsteps] = useState({});


  const [videoSrc, setVideoSrc] = useState(currentSubStepData?.subStepVideoUrl);
  const [hasVideoEnded, setHasVideoEnded] = useState(false);

// Function to check if the progress has been saved locally
const checkLocalProgress = () => {
  const progressKey = `${userId}-step-${currentStep}-substep-${currentSubStep}`;
  return localStorage.getItem(progressKey) === 'true';
};



// Save progress to local storage
const saveLocalProgress = () => {
  const progressKey = `${userId}-step-${currentStep}-substep-${currentSubStep}`;
  localStorage.setItem(progressKey, 'true');
};

  useEffect(() => {
    const videoKey = `${userId}-step-${currentStep}-subStep-${currentSubStep}-watched`;
    
    // Check if the video has been watched before
    const watched = localStorage.getItem(videoKey) === 'true';
    
    setHasVideoEnded(watched); // If watched, skip video and show questions
  }, [currentStep, currentSubStep, userId]);

  useEffect(() => {
    // Check if the user has already passed the current step/substep
    const isPassed = checkLocalProgress();
  
    // Enable "Next" button if user has passed this step before
    if (isPassed) {
      setCanSlide(true);
    } else {
      setCanSlide(false);
    }
  }, [currentStep, currentSubStep]);
  
  
  useEffect(() => {
    if (user) {
      setUserId(user.uid);
    }
  }, [user]);

  useEffect(() => {
    const fetchProgress = async () => {
      if (userId) {
        const docRef = doc(db, "users", userId);
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          const data = docSnap.data();
          const fetchedStep = data.masterClassStep || 0;
          const fetchedSubStep = data.masterClassSubStep || 0;

          const correctedStep = masterclassSteps.find(step => step.id === fetchedStep) ? fetchedStep : masterclassSteps[0]?.id;

          setCurrentStep(correctedStep);
          setCurrentSubStep(fetchedSubStep);

          const completedQuiz = data.answers?.Masterclass?.[currentStepData?.stepTitle]?.[currentSubStepData?.subStepTitle];
          if (completedQuiz || correctedStep < currentStep || fetchedSubStep < currentSubStep) {
            setCanSlide(true);
            setSelectedOptions(completedQuiz || {}); // Load previously selected options
          } else {
            setCanSlide(false);
          }
        }
      }
    };
    fetchProgress();
  }, [userId, currentStepData, currentSubStepData]);

  useEffect(() => {
    if (currentSubStepData && currentSubStepData.questions) {
      setShuffledQuestions(currentSubStepData.questions.sort(() => 0.5 - Math.random()));
      setCurrentQuestionIndex(0); // Reset to first question on sub-step change
    } else {
      setShuffledQuestions([]); // Handle case where there are no questions
    }
  }, [currentSubStepData]);

  useEffect(() => {
    setVideoSrc(currentSubStepData?.subStepVideoUrl);
  }, [currentSubStepData]);

  const updateMasterClassStep = async (stepId, subStepId = 0) => {
    const userDocRef = doc(db, 'users', userId);
    try {
      await updateDoc(userDocRef, { masterClassStep: stepId, masterClassSubStep: subStepId });
      setCurrentStep(stepId);
      setCurrentSubStep(subStepId);
    } catch (error) {
      console.error("Error updating masterclass step: ", error);
    }
  };

  // const handleNextStep = async () => {
  //   saveLocalProgress();  // Save local progress
    
  //   if (currentSubStepData?.questions && currentQuestionIndex < shuffledQuestions.length - 1) {
  //     // Move to the next question in the same sub-step
  //     setCurrentQuestionIndex(currentQuestionIndex + 1);
  //   } else if (currentStepData?.subSteps[currentSubStep + 1]) {
  //     // Move to the next sub-step
  //     const nextSubStepId = currentSubStep + 1;
  //     await updateMasterClassStep(currentStep, nextSubStepId);
  //     setCurrentSubStep(nextSubStepId);  // Update current sub-step
  //     if (sliderRef.current) {
  //       sliderRef.current.slickNext();  // Move slider to the next sub-step
  //       navigate(`/survey/0/${nextSubStepId}`);
  //     }
  //   } else {
  //     // Move to the next step if no more sub-steps
  //     const nextStepId = masterclassSteps[currentStep + 1]?.id;
  //     if (nextStepId) {
  //       await updateMasterClassStep(nextStepId, 1);
  //       await updateUserProgress(userId, currentStepData.area || 'Masterclass', nextStepId);
  //       setCurrentStep(nextStepId);  // Update current step
  //       setCurrentSubStep(1);  // Reset sub-step to 1
  //       if (sliderRef.current) {
  //         sliderRef.current.slickNext();  // Move slider to the next step
  //       }
  //     }
  //   }

  //   window.location.reload();
  // };
  
  const handleNextStep = async () => {
    saveLocalProgress(); // Save local progress
  
    // Move to the next question if more remain
    if (currentSubStepData?.questions && currentQuestionIndex < shuffledQuestions.length - 1) {
      setCurrentQuestionIndex((prevIndex) => prevIndex + 1);
      return;
    }
  
    const nextSubStepId = currentSubStep + 1;
    const userDocRef = doc(db, "users", userId);
  
    try {
      // If this is the last substep, move to Decision Step (ID 1)
      if (isLastSubStep || !currentStepData?.subSteps[nextSubStepId]) {
        const decisionStepId = 1;
        await updateMasterClassStep(decisionStepId, 1);
        await updateUserProgress(userId, currentStepData.area || "Masterclass", decisionStepId);
        await updateDoc(userDocRef, { masterClassStep: decisionStepId, masterClassSubStep: 1 });
  
        setCurrentStep(decisionStepId);
        setCurrentSubStep(1);
        navigate("/survey/1");
        return;
      }

       // Update the completed substeps immediately in state
          setCompletedSubsteps((prev) => ({
            ...prev,
            [nextSubStepId]: true,
          }));

  
      // Fetch user's progress from Firestore
      const userDoc = await getDoc(userDocRef);
      const userData = userDoc.exists() ? userDoc.data() : {};
      const masterclassProgress = userData?.progress?.MasterclassSubsteps || {};
  
      if (masterclassProgress[nextSubStepId]) {
        // Move to the next substep if already unlocked
        await updateMasterClassStep(currentStep, nextSubStepId);
        setCurrentSubStep(nextSubStepId);
        setCurrentQuestionIndex(0);
        navigate(`/survey/0/${nextSubStepId}`);
        if (sliderRef.current) sliderRef.current.slickNext();
      } else {
        // Unlock it in Firestore & then move
        await updateDoc(userDocRef, {
          [`progress.MasterclassSubsteps.${nextSubStepId}`]: true,
        });
  
        await updateMasterClassStep(currentStep, nextSubStepId);
        setCurrentSubStep(nextSubStepId);
        setCurrentQuestionIndex(0);
        navigate(`/survey/0/${nextSubStepId}`);
        if (sliderRef.current) sliderRef.current.slickNext();
      }
    } catch (error) {
      console.error("Error checking/updating Firestore progress:", error);
    }
  };
  
  

  
  const handleBackStep = async () => {
    if (currentSubStep > 1) {
      const previousSubStepId = currentSubStep - 1;
      await updateMasterClassStep(currentStep, previousSubStepId);
      setCurrentSubStep(previousSubStepId); // Update state
      navigate(`/survey/0/${previousSubStepId}`); // 🔥 Update URL
    } else {
      const previousStepIndex = masterclassSteps.findIndex(step => step.id === currentStep) - 1;
      if (previousStepIndex >= 0) {
        const previousStepId = masterclassSteps[previousStepIndex].id;
        await updateMasterClassStep(previousStepId, 1);
        setCurrentStep(previousStepId);
        setCurrentSubStep(1);
        navigate(`/survey/0/1`); // 🔥 Update URL for first substep of the previous step
      }
    }
  
    // Check progress and enable the "Next" button based on saved local progress
    const isPassed = checkLocalProgress();
    setCanSlide(isPassed);
  };
  

  // const handleBackStep = async () => {
  //   if (currentSubStep > 1) {
  //     const previousSubStepId = currentSubStep - 1;
  //     await updateMasterClassStep(currentStep, previousSubStepId);
  //   } else {
  //     const previousStepId = masterclassSteps.findIndex(step => step.id === currentStep) - 1;
  //     if (previousStepId >= 0) {
  //       await updateMasterClassStep(masterclassSteps[previousStepId].id);
  //     }
  //   }
  
  //   // Check progress and enable the "Next" button based on saved local progress
  //   const isPassed = checkLocalProgress();
  //   setCanSlide(isPassed);
  // };
  
  const handlePreviousQuestion = () => {
    if (currentQuestionIndex > 0) {
      setCurrentQuestionIndex((prevIndex) => prevIndex - 1);
    }
  };
  const unlockNextSubstep = async () => {
    if (!user || !user.uid) return;
  
    try {
      const userDocRef = doc(db, "users", user.uid);
      const userDoc = await getDoc(userDocRef);
  
      if (userDoc.exists()) {
        const completedSubsteps = userDoc.data().progress?.MasterclassSubsteps || {};
  
        // Convert keys to numbers & find the first missing substep
        let nextSubStep = Object.keys(completedSubsteps)
          .map(Number) // Ensure numeric order
          .sort((a, b) => a - b)
          .find((step) => !completedSubsteps[step + 1]);
  
        // If substep `2` is missing, unlock it first
        if (!completedSubsteps[2]) {
          nextSubStep = 1; // Force unlocking `2` next
        }
  
        await updateDoc(userDocRef, {
          [`progress.MasterclassSubsteps.${nextSubStep + 1}`]: true,
        });
  
        console.log(`Substep ${nextSubStep + 1} unlocked.`);
      }
    } catch (error) {
      console.error("Failed to unlock next substep:", error);
    }
  };
  
  
  

  const handleQuizCompletion = async (selectedOption, questionId) => {
    setSelectedOptions((prevOptions) => ({
      ...prevOptions,
      [questionId]: selectedOption,
    }));
  
    const isCorrect = selectedOption === shuffledQuestions[currentQuestionIndex]?.correctAnswer;
  
    setCorrectAnswersCount((prevCount) => prevCount + (isCorrect ? 1 : 0));
    setIncorrectAnswersCount((prevCount) => prevCount + (!isCorrect ? 1 : 0));
  
    const totalQuestions = shuffledQuestions.length;
  
    if (currentQuestionIndex < totalQuestions - 1) {
      setCurrentQuestionIndex(currentQuestionIndex + 1);
    } else {
      // Check if user has failed (≥ 2 wrong answers)
      if (incorrectAnswersCount + (!isCorrect ? 1 : 0) >= 2) {
        setCanSlide(false); // Disable Next button
        setShowReviewPopup(true); // Show "Try Again" prompt
      } 
      // Check if user has passed
      else if (correctAnswersCount + (isCorrect ? 1 : 0) >= totalQuestions - 1) {
        setCanSlide(true); // Enable Next button
        await unlockNextSubstep(); // 🔥 Unlock the next Masterclass substep in Firestore
      }
    }
  };

  const handleRetryQuiz = () => {
    setIsRetrying(true); // Set retry state
    setCurrentQuestionIndex(0); // Reset quiz to the first question
    setSelectedOptions({}); // Clear selected options
    setCorrectAnswersCount(0); // Reset correct answers count
    setIncorrectAnswersCount(0); // Reset incorrect answers count
    setCanSlide(false); // Disable Next button until quiz is completed
    setShowReviewPopup(false); // Hide retry prompt
  
    // Reload the video
    const videoKey = `${userId}-step-${currentStep}-subStep-${currentSubStep}-watched`;
    localStorage.removeItem(videoKey); // Remove video watched status
    setHasVideoEnded(false); // Force video to play from the start
  };
  
  
  
  const handleSubmit = async (e) => {
    e.preventDefault();
  
    if (!currentSubStepData?.questions || currentSubStepData?.questions.length === 0) return;
  
    // Create the structure for all questions in the current sub-step
    const result = currentSubStepData.questions.reduce((acc, question) => {
      const selectedOption = selectedOptions[question.id];
      if (!selectedOption) return acc;
  
      const isCorrect = selectedOption === question.correctAnswer;
  
      acc[`answers.Masterclass.${currentSubStepData.subStepTitle}.${question.title}`] = {
        question: question.title,
        isCorrect: isCorrect,
        selectedOption: selectedOption,
      };
  
      return acc;
    }, {});
  
    try {
      // Save all questions' results to Firestore
      if (Object.keys(result).length > 0) {
        await updateDoc(doc(db, "users", userId), result);
      }
  
      // Handle navigation after submission
      if (currentQuestionIndex < shuffledQuestions.length - 1) {
        setCurrentQuestionIndex(currentQuestionIndex + 1);
      } else {
        handleNextStep(); // Move to the next step or sub-step
      }
    } catch (error) {
      console.error("Failed to save all questions for the current sub-step:", error);
    }
  };
  

  const updateCurrentStep = async (newStep) => {
    const userDocRef = doc(db, 'users', userId);
    try {
      await updateDoc(userDocRef, { currentStep: newStep });
      setCurrentStep(newStep);
    } catch (error) {
      console.error("Error updating document: ", error);
    }
  };

  const handleFinishMasterclass = async () => {
    try {
      const decisionStepId = 1;
      await updateMasterClassStep(decisionStepId, 1);
      await updateUserProgress(userId, currentStepData.area || 'Masterclass', decisionStepId);
      await updateCurrentStep(1);
      navigate('/survey/1');
    } catch (error) {
      console.error("Failed to finish masterclass and navigate to the decision step:", error);
    }
  };


  const sliderSettings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    swipe: false,  // Disable swipe, use manual button control
    arrows: false,
    beforeChange: (oldIndex, newIndex) => setActiveSlide(newIndex), // Track active slide
  };
  
  


  if (!currentStepData || !currentSubStepData) {
    return <div>Loading...</div>;
  }


  const handleVideoEnd = () => {
    setHasVideoEnded(true);
    setCanSlide(false); // Disable Next button until quiz is completed
    setShowReviewPopup(false); // Hide retry prompt
  
    // Reset quiz to the start
    setCurrentQuestionIndex(0); // Reset to the first question
    setSelectedOptions({}); // Clear selected options
    setCorrectAnswersCount(0); // Reset correct answers count
    setIncorrectAnswersCount(0); // Reset incorrect answers count
  
    // Save video watched status
    const videoKey = `${userId}-step-${currentStep}-subStep-${currentSubStep}-watched`;
    localStorage.setItem(videoKey, 'true');
  };
  
  
  return (
    <div>
      {/* If it's the first substep (Introduction) */}
      {currentSubStep === 0 ? (
        <div className="flex max-[992px]:flex-col min-h-screen w-full max-[992px]:pt-8">
          <div className="min-[992px]:w-1/2 flex flex-col justify-center items-start min-[1300px]:pt-24 min-[992px]:pr-20 max-[992px]:pr-6 pl-6">
            <StepHeader 
              stepTitle={currentSubStepData.subStepTitle} 
              stepDescription={currentSubStepData.subStepDescription} 
              area="Masterclass"
              className="text-[#fcb900]" 
            />
            <div className="text-center w-full">
              <button 
                onClick={handleNextStep}
                className="mt-6 px-8 py-3 text-black border border-black font-semibold rounded-full transition-colors hover:bg-amber-400"
              >
                Click to Start Masterclass <FontAwesomeIcon className="float-right mt-1 ml-2" icon={faChevronRight} />
              </button>
            </div>
          </div>
          <div className="relative flex items-center justify-center min-[992px]:w-2/3 max-[992px]:mt-8 pt-8 pb-8">
            <button onClick={handleNextStep}>
              <img 
                src={require('../../../assets/getting-started.png')} 
                className="absolute inset-0 w-full h-full max-[1600px]:max-h-[800px] object-cover min-h-[600px] object-[58%]" 
                alt="getting started" 
              />
            </button>
          </div>
        </div>
      ) : currentSubStep === 1 ? (
        <>
          {/* 📱 MOBILE (max 992px) - Special Layout */}
          <div className="max-[992px]:block min-[992px]:hidden">
            <div className="p-4">
              <StepHeader
                stepTitle={currentSubStepData.subStepTitle}
                area="Masterclass"
              />
              <div className="mb-4">
              <VideoComponent
                key={`${videoSrc}-${currentSubStep}-${isRetrying}`}
                src={videoSrc}
                onVideoEnd={handleVideoEnd}
                isActive={true}
              />
              </div>
              <StepHeader
                stepDescription={currentSubStepData.subStepDescription}
                area="Exclude"
              />
              <button
                type="submit"
                onClick={handleNextStep}
                className="px-8 py-3 text-black border border-black font-semibold rounded-full transition-colors hover:bg-amber-400"
              >
                Start Visionary Leaders: Charismatic Soothsayers & Knowledge Seekers
                <FontAwesomeIcon className="float-right mt-1 ml-2" icon={faChevronRight} />
              </button>
            </div>
          </div>
  
          {/* 💻 DESKTOP (min 992px) - Keep original layout */}
          <div className="min-[992px]:block max-[992px]:hidden">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div className="p-4">
                <StepHeader
                  stepTitle={currentSubStepData.subStepTitle}
                  area="Masterclass"
                  stepDescription={currentSubStepData.subStepDescription}
                />
              </div>
              <div className="p-4">
                <Slider ref={sliderRef} {...sliderSettings}>
                  {Object.values(currentStepData.subSteps).map((subStep, subStepIndex) => (
                    <div key={`${subStep.subStepVideoUrl}-${subStepIndex}`}>
                      <VideoComponent
                        key={`${videoSrc}-${currentSubStep}-${isRetrying}`}
                        src={videoSrc}
                        onVideoEnd={handleVideoEnd}
                        isActive={activeSlide === subStepIndex} // Lazy load only if active
                      />
                      {showReviewPopup && (
                        <div className="relative p-4 bg-white border border-gray-300 shadow-lg rounded-md z-50">
                          <h4 className="text-red-600">
                            <strong>Please rewatch the Video and try again.</strong>
                          </h4>
                          <p>Some of your responses were incorrect.</p>
                        </div>
                      )}
                    </div>
                  ))}
                </Slider>
                <div className="mt-4 text-center">
                <button
      type="submit"
      onClick={handleNextStep}
      className={`px-8 py-3 text-black border border-black font-semibold rounded-full transition-colors ${
        currentSubStep === 1
          ? 'hover:bg-amber-400' // No disabled styling for subStep 1
          : !checkLocalProgress() && !canSlide
          ? 'cursor-not-allowed opacity-50'
          : 'hover:bg-amber-400'
      }`}
      disabled={currentSubStep === 1 ? false : !checkLocalProgress() && !canSlide}
    >
      {currentSubStep === 1 ? 'Start Visionary Leaders: Charismatic Soothsayers & Knowledge Seekers' : 'Next'}
      <FontAwesomeIcon className="float-right mt-1 ml-2" icon={faChevronRight} />
    </button>

              </div>
              </div>
            </div>
          </div>
        </>
      ) : (
        // Default case for all other substeps
        <div>
          {isLastSubStep ? (
            <div>
              <StepHeader 
                stepTitle="Congratulations! You have passed the Masterclass." 
                stepDescription="You can proceed to the next stage." 
                area="Masterclass" 
              />
              <button 
                onClick={handleFinishMasterclass} 
                className="px-8 py-3 text-black border border-black font-semibold rounded-full transition-colors hover:bg-amber-400"
              >
                Finish Masterclass
              </button>
            </div>
          ) : (
            <>
  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
    <div className="p-4">
      <StepHeader
        stepTitle={currentSubStepData.subStepTitle}
        stepDescription={currentSubStepData.subStepDescription}
        area="Masterclass"
      />
    </div>
    <div className="p-4">
      <Slider ref={sliderRef} {...sliderSettings}>
        {Object.values(currentStepData.subSteps).map((subStep, subStepIndex) => (
          <div key={`${subStep.subStepVideoUrl}-${subStepIndex}`}>
            <VideoComponent
              key={`${videoSrc}-${currentSubStep}-${isRetrying}`}
              src={videoSrc}
              onVideoEnd={handleVideoEnd}
              isActive={activeSlide === subStepIndex} // Lazy load only if active

            />
            {showReviewPopup && (
              <div className="relative p-4 bg-white border border-gray-300 shadow-lg rounded-md z-50">
                <h4 className="text-red-600">
                  <strong>Please rewatch the Video and try again.</strong>
                </h4>
                <p>Some of your responses were incorrect.</p>
              </div>
            )}
            {hasVideoEnded && (
              <>
              <h3 className="font-bold text-2xl mt-4">QUIZ</h3>
              <form onSubmit={handleSubmit} className="">
                {currentSubStep !== 1 && (
                  <QuizComponent
                    key={shuffledQuestions[currentQuestionIndex]?.id}
                    question={shuffledQuestions[currentQuestionIndex]}
                    selectedOption={selectedOptions[shuffledQuestions[currentQuestionIndex]?.id]}
                    onComplete={handleQuizCompletion}
                    currentStep={currentStep}
                    questionNumber={currentQuestionIndex + 1}
                  />
                )}
          {/* <div className="button-group mt-4 flex justify-between">
  {currentSubStep > 1 && (
    <button
      type="button"
      onClick={handleBackStep}
      className="mr-4 px-8 py-3 text-black border border-black font-semibold rounded-full hover:bg-amber-400 transition-colors"
    >
      <FontAwesomeIcon className="float-left mt-1 mr-2" icon={faChevronLeft} /> Prev
    </button>
  )}
  {showReviewPopup ? (
    <button
      type="button"
      onClick={handleRetryQuiz}
      className="px-8 py-3 text-black border border-black font-semibold rounded-full hover:bg-amber-400 transition-colors"
    >
      Rewatch the Video and Try Again <FontAwesomeIcon className="float-right mt-1 ml-2" icon={faPlay} />
    </button>
  ) : (
    <button
      type="submit"
      onClick={handleNextStep}
      className={`px-8 py-3 text-black border border-black font-semibold rounded-full transition-colors ${
        currentSubStep === 1
          ? 'hover:bg-amber-400' // No disabled styling for subStep 1
          : !checkLocalProgress() && !canSlide
          ? 'cursor-not-allowed opacity-50'
          : 'hover:bg-amber-400'
      }`}
      disabled={currentSubStep === 1 ? false : !checkLocalProgress() && !canSlide}
    >
      {currentSubStep === 1 ? 'Start Visionary Leaders: Charismatic Soothsayers & Knowledge Seekers' : 'Next'}
      <FontAwesomeIcon className="float-right mt-1 ml-2" icon={faChevronRight} />
    </button>
  )}
</div> */}
<div className="button-group mt-4 flex justify-between">
  {/*  Previous Quiz Question Button */}
  {currentQuestionIndex > 0 && (
    <button
      type="button"
      onClick={handlePreviousQuestion}
      className="px-8 py-3 text-black border border-black font-semibold rounded-full hover:bg-amber-400 transition-colors"
    >
      <FontAwesomeIcon className="float-left mt-1 mr-2" icon={faChevronLeft} /> Prev Question
    </button>
  )}

  {/*  Previous Sub-Step Button */}
  {currentSubStep > 1 && currentQuestionIndex === 0 && (
    <button
      type="button"
      onClick={handleBackStep}
      className="mr-4 px-8 py-3 text-black border border-black font-semibold rounded-full hover:bg-amber-400 transition-colors"
    >
      <FontAwesomeIcon className="float-left mt-1 mr-2" icon={faChevronLeft} /> Prev Step
    </button>
  )}

  {/* Retry Button (Shown when quiz is failed) */}
  {showReviewPopup ? (
    <button
      type="button"
      onClick={handleRetryQuiz}
      className="px-8 py-3 text-black border border-black font-semibold rounded-full hover:bg-amber-400 transition-colors"
    >
      Rewatch the Video and Try Again <FontAwesomeIcon className="float-right mt-1 ml-2" icon={faPlay} />
    </button>
  ) : (
    /* ➡️ Next Button */
    <button
      type="submit"
      onClick={handleNextStep}
      className={`px-8 py-3 text-black border border-black font-semibold rounded-full transition-colors ${
        currentSubStep === 1
          ? 'hover:bg-amber-400'
          : !checkLocalProgress() && !canSlide
          ? 'cursor-not-allowed opacity-50'
          : 'hover:bg-amber-400'
      }`}
      disabled={currentSubStep === 1 ? false : !checkLocalProgress() && !canSlide}
    >
      {currentSubStep === 1 ? 'Start Visionary Leaders: Charismatic Soothsayers & Knowledge Seekers' : 'Next'}
      <FontAwesomeIcon className="float-right mt-1 ml-2" icon={faChevronRight} />
    </button>
  )}
</div>


              </form>
              </>
            )}
          </div>
        ))}
      </Slider>
    </div>
  </div>
</>

          )}
        </div>
      )}
    </div>
  );
};


export default MasterClass;
